import type { CheckboxGroupProps } from 'antd/lib/checkbox';
import { useField } from 'formik';
import React, { memo, useCallback } from 'react';
import { useThemeComponents } from '../../themes';
import FormItem, { type FormItemProps } from './FormItem';

export interface CheckboxGroupFieldProps extends Omit<CheckboxGroupProps, 'onChange'> {
    name: string;
    label?: string;
    itemProps?: Omit<FormItemProps, 'label' | 'meta' | 'required' | 'children'>;
    required?: boolean;
}

const CheckboxGroupField = ({ name, required, label, ...props }: CheckboxGroupFieldProps) => {
    const [field, meta, { setValue }] = useField({ name });
    const { CheckboxGroup } = useThemeComponents();

    const onChange = useCallback(checkedValue => setValue(checkedValue), [setValue]);

    return (
        <FormItem label={label} meta={meta} required={required}>
            <CheckboxGroup
                // spread props
                {...props}
                // then spread the field properties itself
                {...field}
                onChange={onChange}
            />
        </FormItem>
    );
};

export default memo(CheckboxGroupField);
